import React, { useCallback } from "react";
import "./header.css"; // Import the CSS file for styling
import { useLocation, useNavigate } from "react-router-dom";
import Menu from "antd/es/menu";
import { getUserName } from "../../services/utils";
import { CaretDownOutlined } from "@ant-design/icons";
import { useUser } from "../../user-context";
import { handleLogout } from "./utils";

interface HeaderProps {
  isAuthenticated: any;
  role: any;
}

const Header: React.FC<HeaderProps> = ({ isAuthenticated, role }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userRole } = useUser();

  const currentSelection = location.pathname;

  const navigateMenu = useCallback(
    (e: any) => {
      navigate(e.key);
    },
    [navigate],
  );

  // Define the menu items based on userRole
  const items = (() => {
    if (!userRole || currentSelection === "/user-registration") {
      // If userRole is null, "", or undefined, return an empty array
      return [];
    }

    // If userRole is "admin", include the Admin item
    const baseItems = [
      {
        label: "Dashboard",
        key: "/dashboard",
      },
    ];

    // Conditionally add the Admin item based on userRole
    if (
      userRole.toLowerCase() !== "supplier" &&
      userRole.toLowerCase() !== "merck_supplier"
    ) {
      baseItems.push({ label: "Package History", key: "/package-history" });
    }

    if (userRole.toLowerCase() === "admin") {
      baseItems.push({ label: "Admin", key: "/admin" });
    }

    return baseItems;
  })();

  const userMenu = [
    {
      key: "userOptions",
      label: (
        <div style={{ minWidth: "9rem" }}>
          {getUserName()}{" "}
          <CaretDownOutlined
            style={{ color: "black", fontSize: "12px", marginLeft: "5px" }}
          />
        </div>
      ),
      children: [
        {
          key: "logout",
          label: "Logout",
          onClick: () => handleLogout(),
        },
      ],
    },
  ];

  const selectedKey = items.find((item) =>
    currentSelection.startsWith(item.key),
  )?.key || "";

  return (
    <header className="header">
      <div className="header-content">
        <img src="/logo.png" alt="Logo" className="logo" />
        {isAuthenticated &&
          items.length > 0 && (
            <>
              <Menu
                selectedKeys={[selectedKey]}
                mode="horizontal"
                items={items}
                onClick={navigateMenu}
                style={{
                  minWidth: 0,
                  flex: "auto",
                  borderBottom: "none",
                }}
              />
              <Menu
                mode="horizontal"
                style={{
                  borderBottom: "none",
                  display: "flex",
                  justifyContent: "center",
                }}
                items={userMenu}
              />
            </>
          )}
      </div>
    </header>
  );
};

export default Header;
